import 'angular:locale/data:ar';
import 'angular:locale/data:ru';
import 'angular:locale/data:he';
import 'angular:locale/data:en-US';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
